import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/layout/PageHeader';
import { MessageRouteForm } from '../components/messageRoutes/MessageRouteForm';
import { useCreateMessageRoute } from '../hooks/useMessageRoutes';

export default function NewMessageRoutePage() {
  const navigate = useNavigate();
  const createMessageRoute = useCreateMessageRoute();

  const handleSubmit = async (data: Record<string, unknown>) => {
    const result = await createMessageRoute.mutateAsync(data as Parameters<typeof createMessageRoute.mutateAsync>[0]);
    navigate(`/message-routes/${result.id}`);
  };

  return (
    <div>
      <PageHeader
        title="Create Message Route"
        description="Configure a new routing rule to automate responses to real-time events"
      />
      <div className="mt-6 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
        <MessageRouteForm mode="create" onSubmit={handleSubmit} />
      </div>
    </div>
  );
}
